<div class="pricing-container">
  <div class="header">
    <h1>Choose Your Plan</h1>
    <p>Unlock more features and grow your fanbase.</p>
    <mat-button-toggle-group
      [(ngModel)]="billingCycle"
      aria-label="Billing Cycle"
    >
      <mat-button-toggle value="monthly">Monthly</mat-button-toggle>
      <mat-button-toggle value="yearly">Yearly (Save 20%)</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="plans-wrapper">
    <div
      *ngFor="let plan of plans"
      class="plan-card"
      [class.popular]="plan.popular"
    >
      <div *ngIf="plan.popular" class="popular-badge">Most Popular</div>
      <div class="plan-header">
        <h2>{{ plan.name }}</h2>
        <p class="description">{{ plan.description }}</p>
        <div class="price-section">
          <ng-container *ngIf="billingCycle === 'monthly'">
            <span class="price" *ngIf="isNumber(plan.price.monthly)">{{
              plan.price.monthly | currency
            }}</span>
            <span class="price" *ngIf="!isNumber(plan.price.monthly)">{{
              plan.price.monthly
            }}</span>
            <span class="billing-period" *ngIf="isNumber(plan.price.monthly)"
              >/ month</span
            >
          </ng-container>
          <ng-container *ngIf="billingCycle === 'yearly'">
            <span class="price" *ngIf="isNumber(plan.price.yearly)">{{
              plan.price.yearly | currency
            }}</span>
            <span class="price" *ngIf="!isNumber(plan.price.yearly)">{{
              plan.price.yearly
            }}</span>
            <span class="billing-period" *ngIf="isNumber(plan.price.yearly)"
              >/ year</span
            >
          </ng-container>
        </div>
      </div>
      <ul class="features-list">
        <li *ngFor="let feature of plan.features">
          <mat-icon>check</mat-icon> {{ feature }}
        </li>
      </ul>
      <div class="plan-extra-details">
        <div class="detail-item">
          <strong>Platform Fee</strong>
          <span>{{ plan.platformFee }}</span>
        </div>
        <div class="detail-item">
          <strong>Payout Speed</strong>
          <span>{{ plan.payoutSpeed }}</span>
        </div>
      </div>
      <div class="cta-wrapper">
        <button
          mat-raised-button
          [color]="plan.popular ? 'accent' : 'primary'"
          (click)="selectPlan(plan)"
          [disabled]="plan.disabled || loadingPlan === plan.name"
        >
          <ng-container *ngIf="loadingPlan !== plan.name">{{
            plan.cta
          }}</ng-container>
          <ng-container *ngIf="loadingPlan === plan.name"
            >Processing...</ng-container
          >
        </button>
      </div>
    </div>
  </div>
</div>
